import BulkDriverPolygonIdApi from "../../services/api/BulkUploadDriverPolygonId";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in bulk upload driver polygon id:", err);
}

export const bulkUploadDriverPolygonId = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await BulkDriverPolygonIdApi.bulkUploadDriverPolygonId(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};